export default __webpack_public_path__ + "static/media/Item_Hero's_Wit.a79e36d0.png";